import React, { Component } from 'react';
import styles from './RegisterForm.module.scss';
import classNames from 'classnames/bind';
import { withFormik, Field } from 'formik';
import * as yup from 'yup';

import {BlueButton, Divider, LabelText, RadioButton, Header, SubHeader, ContactUsText, AwairLogo} from '../../atoms';
import {RadioButtonGroup} from '../../molecules';
import {InputGroup, SelectGroup} from '../../organisms';
import { registerFormContentsEn, registerFormContentsKr } from '../../../assets/contents/register-form';

const cx = classNames.bind(styles);

class RegisterForm extends Component {
  render() {
    const { values, handleChange, handleBlur, handleSubmit, touched, errors, setFieldTouched, setFieldValue, email, language } = this.props;
    const textContents = language === 'ko' ? registerFormContentsKr : registerFormContentsEn;
    const {
      header,
      headerDescription,
      passwordGuide,
      confirmPasswordGuide,
      requiredGuide,
      contactUsDescription,
      labelText,
      placeholderText,
      submitButtonText,
      birthYearSelectOptions
    } = textContents;
    return (
      <div>
        <AwairLogo className={cx('RegisterForm__awair-logo')}/>
        <form className={cx('RegisterForm')} onSubmit={handleSubmit}>
          <Header text={header} />
          <SubHeader text={headerDescription}/>
          <Divider />
          <LabelText text={labelText.email} className={cx('RegisterForm__label-email')} />
          <p className={cx('RegisterForm__email')}>{email}</p>
          <InputGroup
            className={cx('RegisterForm__input-group')}
            inputType="password"
            inputName="password"
            inputPlaceholder={placeholderText.password}
            labelText={labelText.password}
            isError={touched.password && errors.password}
            value={values.password}
            onChange={handleChange}
            onBlur={handleBlur}
            inputGuideText={passwordGuide}
          />
          <InputGroup
            className={cx('RegisterForm__input-group')}
            inputType="password"
            inputName="confirmPassword"
            inputPlaceholder={placeholderText.confirmPassword}
            labelText={labelText.confirmPassword}
            isError={touched.confirmPassword && values.password !== values.confirmPassword}
            value={values.confirmPassword}
            onChange={handleChange}
            onBlur={handleBlur}
            inputGuideText={confirmPasswordGuide}
            defaultHideGuide={true}
          />
          <div className={cx('RegisterForm__two-columns')}>
            <InputGroup
              className={cx(
                'RegisterForm__input-group',
                'RegisterForm__two-columns-column',
                'RegisterForm__two-columns-column-left',
                'RegisterForm__input-group-first-name'
              )}
              inputType="text"
              inputName="firstName"
              inputPlaceholder={placeholderText.firstName}
              labelText={labelText.firstName}
              isError={touched.firstName && errors.firstName}
              value={values.firstName}
              onChange={handleChange}
              onBlur={handleBlur}
              inputGuideText={requiredGuide}
              defaultHideGuide={true}
            />
            <InputGroup
              className={cx('RegisterForm__input-group', 'RegisterForm__two-columns-column')}
              inputType="text"
              inputName="lastName"
              inputPlaceholder={placeholderText.lastName}
              labelText={labelText.lastName}
              isError={touched.lastName && errors.lastName}
              value={values.lastName}
              onChange={handleChange}
              onBlur={handleBlur}
              inputGuideText={requiredGuide}
              defaultHideGuide={true}
            />
          </div>
          <div className={cx('RegisterForm__two-columns')}>
            <RadioButtonGroup
              labelText={labelText.gender}
              isError={errors.radioGroup && touched.radioGroup}
              inputGuideText={requiredGuide}
              defaultHideGuide={true}
              className={cx('RegisterForm__gender', 'RegisterForm__two-columns-column', 'RegisterForm__two-columns-column-left')}
            >
              <Field component={RadioButton} name="radioGroup" id="RegisterForm__RadioButton__male" labelText={labelText.male} />
              <Field component={RadioButton} name="radioGroup" id="RegisterForm__RadioButton__female" labelText={labelText.female} />
            </RadioButtonGroup>
            <SelectGroup
              className={cx('RegisterForm__two-columns-column')}
              selectName="birthYears"
              labelText={labelText.birthYears}
              isError={touched.birthYears && errors.birthYears}
              value={values.birthYears}
              options={birthYearSelectOptions}
              onChange={setFieldValue}
              onBlur={setFieldTouched}
              inputGuideText={requiredGuide}
              defaultHideGuide={true}
            />
          </div>
          <Divider />
          <BlueButton className={cx('RegisterForm__submit-button')} type="submit" text={submitButtonText} />
        </form>
        <ContactUsText text={contactUsDescription} mailLink='hello@getawair.com'/>
      </div>
    );
  }
}

const validUserSchema = yup.object().shape({
  password: yup
    .string()
    .matches(/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d#?!@$%^&*-]{6,}$/)
    .required()
});

export default  withFormik({
  handleSubmit: async (values, { props }) => {
    const {uuid, email, submit, language} = props;
    const {password, firstName, lastName} = values;
    let birthYears = values.birthYears;
    let radioGroup = values.radioGroup;

    if (birthYears && birthYears.value) {
      birthYears = birthYears.value;
    }

    if (radioGroup.includes("female")) {
      radioGroup = "FEMALE";
    } else if (radioGroup.includes("male")) {
      radioGroup = "MALE";
    } else {
      radioGroup = "UNKNOWN";
    }

    submit(uuid, email, language, password, firstName, lastName, birthYears, radioGroup);
  },
  mapPropsToValues: () => ({
    password: '',
    confirmPassword: '',
    firstName: '',
    lastName: '',
    radioGroup: '',
    birthYears: ''
  }),
  validationSchema: validUserSchema
})(RegisterForm);
